import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { useFarbwelt } from "@/hooks";
import { useIsNewBuildProject } from "@/shared/hooks";
import { AdSlotIds } from "@/shared/types";
import { AdContainer } from "./AdContainer";
import { useIsAdLeaderboardHidden } from "@/components/contacting/hooks/useIsAdLeaderboardHidden";
export const LeaderBoard = () => {
    const { isFarbweltActive } = useFarbwelt();
    const isPreviewMode = useIsPreviewMode();
    const isProject = useIsNewBuildProject();
    const isAdLeaderboardHidden = useIsAdLeaderboardHidden();
    if (isFarbweltActive || isPreviewMode || isProject || isAdLeaderboardHidden) {
        return null;
    }
    return (_jsx(Box, { marginTop: "spacing.16", display: {
            "breakpoint.base": "none",
            "breakpoint.lg": "block",
        }, children: _jsx(AdContainer, { adSlotId: AdSlotIds.AD_LEADERBOARD, width: "728px", height: "90px", display: {
                "breakpoint.base": "none",
                "breakpoint.lg": "flex",
            }, showLabel: true, showFallback: true }) }));
};
